// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-stepper[data-v-063aea0d] .v-stepper__step__step {\r\n  color: transparent !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
